import { render, staticRenderFns } from "./simplifyOwnerShopFee.vue?vue&type=template&id=05833ec6&scoped=true"
import script from "./simplifyOwnerShopFee.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerShopFee.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerShopFee.vue?vue&type=style&index=0&id=05833ec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05833ec6",
  null
  
)

export default component.exports